import { render, staticRenderFns } from "./HomeLargeScreen.vue?vue&type=template&id=fa48a44a&scoped=true"
import script from "./HomeLargeScreen.vue?vue&type=script&lang=js"
export * from "./HomeLargeScreen.vue?vue&type=script&lang=js"
import style0 from "./HomeLargeScreen.vue?vue&type=style&index=0&id=fa48a44a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa48a44a",
  null
  
)

export default component.exports